module.exports = __webpack_public_path__ + "static/media/claro.ab60f5f1.png";